import { SportOfferUIStore } from '@store/modules/ui/sportOffer/sports/sportsIndex';
import {
    useI18n,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    ref,
    watch,
} from '@vue/composition-api';
import { sportName as getSportName } from '@modules/eventGrid/nameExtractors';
import { NavigationDataStore } from '@store/modules/navigation';
import { processContentTitle } from '@src/app/seo/helpers';

export function useSportPageTitle() {
    const { translate } = useI18n();
    const navigationModule = useVuexStore<NavigationDataStore>('navigation');
    const sportOfferUiStore = useVuexStore<SportOfferUIStore>('ui/sportOffer/sports');
    const currentSportId = sportOfferUiStore.getter('currentSportId');

    const sportName = computed(
        () => currentSportId.value ? getSportName(currentSportId.value) : translate('all'));

    const title = ref(sportName.value);
    watch([
        navigationModule.getter('routeSeoData'),
        sportName,
    ], ([seoData, newSportName]) => {
        if (seoData?.title === null) {
            title.value = newSportName;
        } else if (seoData?.title) {
            title.value = processContentTitle(seoData.title, newSportName);
        }
    }, { immediate: true });

    return {
        title,
    };
}
